module.exports = "/fonts/vendor/slick-carousel/slick/slick.woff?b7c9e1e479de3b53f1e4e30ebac2403a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/fonts/slick.woff
// module id = 7nf5
// module chunks = 1